"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertyConditionAttributeShape = exports.constraintsShape = exports.dataSheetsShape = exports.propertyShape = exports.assignmentShape = exports.constraintRuleShape = exports.constraintConditionShape = exports.optionShape = exports.atttributeShape = exports.valueShape = exports.rangeShape = exports.unitOfMeasureShape = exports.intlShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _operators = require("./enums/operators");

var _options = require("./enums/options");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var intlShape = {
  formatMessage: _propTypes["default"].func.isRequired
};
exports.intlShape = intlShape;
var unitOfMeasureShape = {
  unitOfMeasureType: _propTypes["default"].string,
  unitOfMeasure: _propTypes["default"].string
};
exports.unitOfMeasureShape = unitOfMeasureShape;
var rangeShape = {
  minimum: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  maximum: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  increment: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  integer: _propTypes["default"].bool
};
exports.rangeShape = rangeShape;
var valueShape = {
  type: _propTypes["default"].oneOf([_options.VALUE, _options.RANGE, _operators.FORMULA]),
  description: _propTypes["default"].string,
  value: _propTypes["default"].string,
  range: _propTypes["default"].shape(rangeShape),
  formula: _propTypes["default"].string
};
exports.valueShape = valueShape;

var valuesPropType = _propTypes["default"].arrayOf(_propTypes["default"].shape(valueShape));

var atttributeShape = {
  name: _propTypes["default"].string,
  description: _propTypes["default"].string,
  type: _propTypes["default"].string,
  values: valuesPropType
};
exports.atttributeShape = atttributeShape;
var optionShape = {
  name: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  type: _propTypes["default"].string,
  unitOfMeasure: _propTypes["default"].string,
  values: valuesPropType
};
exports.optionShape = optionShape;
var constraintConditionShape = {
  attribute: _propTypes["default"].string,
  values: valuesPropType,
  operator: _propTypes["default"].oneOf(Object.values(_operators.OPERATOR_TYPES))
};
exports.constraintConditionShape = constraintConditionShape;
var constraintRuleShape = {
  name: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  conditions: _propTypes["default"].arrayOf(_propTypes["default"].shape(constraintConditionShape)),
  results: _propTypes["default"].arrayOf(_propTypes["default"].shape(constraintConditionShape))
};
exports.constraintRuleShape = constraintRuleShape;
var assignmentShape = {
  type: _propTypes["default"].string,
  value: _propTypes["default"].string,
  formula: _propTypes["default"].string
};
exports.assignmentShape = assignmentShape;
var propertyShape = {
  name: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  type: _propTypes["default"].string,
  unitOfMeasure: _propTypes["default"].string,
  staticAssignment: _propTypes["default"].shape(assignmentShape),
  assignments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    conditions: _propTypes["default"].arrayOf(_propTypes["default"].shape(constraintConditionShape)),
    result: _propTypes["default"].shape(assignmentShape)
  }))
};
exports.propertyShape = propertyShape;
var dataSheetsShape = {
  name: _propTypes["default"].string.isRequired,
  rows: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    terms: _propTypes["default"].arrayOf({
      key: _propTypes["default"].string.isRequired,
      operator: _propTypes["default"].oneOf(Object.values(_operators.OPERATOR_TYPES)).isRequired,
      values: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        type: _propTypes["default"].oneOf([_options.RANGE, _options.VALUE]).isRequired,
        value: _propTypes["default"].string,
        range: _propTypes["default"].shape({
          rangeShape: rangeShape
        })
      }))
    })
  }))
};
exports.dataSheetsShape = dataSheetsShape;
var constraintsShape = {
  dataSheets: _propTypes["default"].arrayOf(_propTypes["default"].shape(dataSheetsShape)),
  rules: _propTypes["default"].arrayOf(_propTypes["default"].shape(constraintRuleShape))
};
exports.constraintsShape = constraintsShape;
var propertyConditionAttributeShape = {
  name: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  type: _propTypes["default"].string,
  unitOfMeasure: _propTypes["default"].string,
  values: valuesPropType,
  staticAssignment: _propTypes["default"].shape(assignmentShape),
  assignments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    conditions: _propTypes["default"].arrayOf(_propTypes["default"].shape(constraintConditionShape)),
    result: _propTypes["default"].shape(assignmentShape)
  }))
};
exports.propertyConditionAttributeShape = propertyConditionAttributeShape;